<template>
  <v-form>
    <v-row dense>
      <v-col cols="12" xs="12" md="4">
        <v-text-field
          type="text"
          autocomplete="off"
          outlined
          dense
          label="Title"
          v-model="record.name"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="4">
        <v-text-field
          type="number"
          autocomplete="off"
          outlined
          dense
          label="Days"
          v-model="record.days"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-btn
          v-if="docCreate == true"
          color="primary"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon> Create Terms
        </v-btn>

        <v-btn
          v-else
          color="primary"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon> Update Terms
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    loader: false,
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      this.record.days = parseInt(this.record.days);
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
  },
};
</script>